import { get, patch, post, remove } from "../http-client/client";
import { ApiResponse } from "../http-client/Response";

export interface WorkspaceAdmin {
  id: string;
  name: string;
  slug: string | null;
  displayName: string | null;
  isWorkspace: boolean;
  domains: { id: string; domain: string; autoJoin: boolean; verified: boolean }[];
  allowlist: { id: string; email: string | null; domain: string | null }[];
  branding: { logoLightS3Key: string | null } | null;
}

export const getWorkspaceAdmin = (orgId: string): Promise<ApiResponse<WorkspaceAdmin>> =>
  get(`/admin/workspaces/${orgId}`, null);

export const convertToWorkspace = (
  orgId: string,
  slug: string,
  displayName?: string,
): Promise<ApiResponse<WorkspaceAdmin>> =>
  post(`/admin/workspaces/${orgId}/convert`, { slug, displayName }, null);

export const updateWorkspaceName = (
  orgId: string,
  displayName: string,
): Promise<ApiResponse<WorkspaceAdmin>> =>
  patch(`/admin/workspaces/${orgId}`, { displayName }, null);

export const addAllowlistEntry = (
  orgId: string,
  entry: { email?: string; domain?: string },
): Promise<ApiResponse<WorkspaceAdmin>> =>
  post(`/admin/workspaces/${orgId}/allowlist`, entry, null);

export const removeAllowlistEntry = (
  orgId: string,
  entryId: string,
): Promise<ApiResponse<WorkspaceAdmin>> =>
  remove(`/admin/workspaces/${orgId}/allowlist/${entryId}`, null);

export const addWorkspaceDomain = (
  orgId: string,
  domain: string,
  autoJoin: boolean,
): Promise<ApiResponse<WorkspaceAdmin>> =>
  post(`/admin/workspaces/${orgId}/domains`, { domain, autoJoin }, null);

export const removeWorkspaceDomain = (
  orgId: string,
  domainId: string,
): Promise<ApiResponse<WorkspaceAdmin>> =>
  remove(`/admin/workspaces/${orgId}/domains/${domainId}`, null);
